import React from 'react';
import { FaChevronUp, FaChevronDown } from "react-icons/fa";
import style from "./Carta.module.css";

const MiRomanaDropdown = ({ 
  miRomanaVisible,
  onToggleMiRomana,
  onMiRomanaOption,
  miRomanaRef
}) => {
  return (
    <div className={style.mi_romana_container} ref={miRomanaRef}>
      <button 
        className={style.formato_botones}
        onClick={onToggleMiRomana}
      >
        Mi Romana {miRomanaVisible ? <FaChevronUp size={12} /> : <FaChevronDown size={12} />}
      </button>
      {miRomanaVisible && (
        <div className={style.mi_romana_dropdown}>
          <button 
            className={style.mi_romana_option} 
            onClick={() => onMiRomanaOption('favoritos')}
          >
            Favoritos
          </button>
          <button 
            className={style.mi_romana_option} 
            onClick={() => onMiRomanaOption('historial')}
          >
            Historial de pedidos
          </button>
        </div>
      )}
    </div>
  );
};

export default MiRomanaDropdown;